module.exports = __webpack_public_path__ + "img/thiruvalluvar.651637ab.png";